import type { TypeColor } from "@sproutsocial/seeds-react-theme";
import type { TypeChartLegendTheme } from "./ChartLegendTypes";

export const getChartLegendSwatchColor = (
  theme: TypeChartLegendTheme,
  index: number,
  racineThemeColors: TypeColor
) => {
  const COMPARE_THEME = [
    racineThemeColors.dataviz.map["1"],
    racineThemeColors.dataviz.map["10"],
    racineThemeColors.dataviz.map["11"],
    racineThemeColors.dataviz.map["2"],
  ];

  const CONTRAST_THEME = [
    racineThemeColors.dataviz.map["1"],
    racineThemeColors.dataviz.map["2"],
    racineThemeColors.dataviz.map["3"],
    racineThemeColors.dataviz.map["4"],
    racineThemeColors.dataviz.map["5"],
    racineThemeColors.dataviz.map["6"],
    racineThemeColors.dataviz.map["4"],
    racineThemeColors.dataviz.map["5"],
    racineThemeColors.dataviz.map["6"],
    racineThemeColors.dataviz.map["7"],
    racineThemeColors.dataviz.map["8"],
    racineThemeColors.dataviz.map["9"],
    racineThemeColors.dataviz.map["10"],
  ];

  const EXTENDED_THEME = [
    racineThemeColors.dataviz.map["7"],
    racineThemeColors.dataviz.map["1"],
    racineThemeColors.dataviz.map["5"],
    racineThemeColors.dataviz.map["11"],
    racineThemeColors.dataviz.map["6"],
    racineThemeColors.dataviz.map["3"],
    racineThemeColors.dataviz.map["18"],
    racineThemeColors.dataviz.map["8"],
    racineThemeColors.dataviz.map["4"],
    racineThemeColors.dataviz.map["13"],
    racineThemeColors.dataviz.map["16"],
    racineThemeColors.dataviz.map["10"],
    racineThemeColors.dataviz.map["14"],
    racineThemeColors.dataviz.map["2"],
    racineThemeColors.dataviz.map["15"],
    racineThemeColors.dataviz.map["12"],
    racineThemeColors.dataviz.map["9"],
    racineThemeColors.dataviz.map["17"],
    racineThemeColors.dataviz.map["20"],
    racineThemeColors.dataviz.map["19"],
  ];

  type ThemeKeys = "COMPARE" | "CONTRAST" | "EXTENDED" | "DATAVIZROTATION";

  const THEME_MAP: Record<ThemeKeys, any> = {
    COMPARE: COMPARE_THEME,
    CONTRAST: CONTRAST_THEME,
    EXTENDED: EXTENDED_THEME,
    DATAVIZROTATION: racineThemeColors.dataviz.list,
  };

  return THEME_MAP[theme.toUpperCase() as ThemeKeys][index];
};
